const uuid = require('./uuid.js')
const {addPartToVM} = require('./import-part.js')

function setExposedVariables (vm, exposedVariables) {
  exposedVariables.forEach(exposedVar => {
    const varTarget = vm.runtime.targets.find(
      t => t.sprite.name === exposedVar.spriteName
    )
    const variables = Object.values(varTarget.variables)
    let existingVar = variables.find(
      v => v.name === exposedVar.variableName
    )
    if (!existingVar && exposedVar.isList === false) {
      existingVar = varTarget.lookupOrCreateVariable(
        uuid(),
        exposedVar.variableName
      )
    } else {
      if (!existingVar && exposedVar.isList) {
        existingVar = varTarget.lookupOrCreateList(
          uuid(),
          exposedVar.variableName
        )
      }
    }
    if (existingVar) {
      existingVar.value = exposedVar.value
    }
  })
}

function addStartingParts (vm, startingParts, availableParts, addedParts) {
  if (!startingParts || startingParts.length === 0) {
    return Promise.resolve()
  }
  const addPartsPromises = []
  startingParts.forEach(startingPart => {
    const coords = {x: 0, y: 0}
    const part = availableParts.find(p => p.id === startingPart.partId)
    addPartsPromises.push(addPartToVM(part, vm, coords, addedParts))
  })
  return Promise.all(addPartsPromises)
}

module.exports = {addStartingParts, setExposedVariables}


